import { render, staticRenderFns } from "./SvgSymbols.vue?vue&type=template&id=04e912af&scoped=true"
import script from "./SvgSymbols.vue?vue&type=script&lang=js"
export * from "./SvgSymbols.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e912af",
  null
  
)

export default component.exports